import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=2c827467&scoped=true"
import script from "./Modal.vue?vue&type=script&lang=ts"
export * from "./Modal.vue?vue&type=script&lang=ts"
import style0 from "./Modal.vue?vue&type=style&index=0&id=2c827467&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c827467",
  null
  
)

export default component.exports